import { render, staticRenderFns } from "./progressRate.vue?vue&type=template&id=5b036b04&scoped=true"
import script from "./progressRate.vue?vue&type=script&lang=js"
export * from "./progressRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b036b04",
  null
  
)

export default component.exports